import { render, staticRenderFns } from "./homepage2.vue?vue&type=template&id=ec7fb22a&scoped=true&"
import script from "./homepage2.vue?vue&type=script&lang=js&"
export * from "./homepage2.vue?vue&type=script&lang=js&"
import style0 from "./homepage2.vue?vue&type=style&index=0&id=ec7fb22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7fb22a",
  null
  
)

export default component.exports